import React, {useEffect, useRef, useState} from "react";
import {
    Body1,
    Body1PointerLink,
    Body1PointerLinkXl,
    Body1PointerLinkXs,
    Title,
    TitleСontact
} from "../../../../components/Font";
import {
    AvatarImg,
    ContactInfo,
    ContactPhoneEmail,
    DescrPhoneEmail,
    FormAvatar,
    Hr,
    IconContent,
    Layer,
    PersonInfoContent,
    SelectedFormAvatar,
    TitlePhoneEmail,
    UserDataContent,
    UserInfo,
    UserInfoContact,
    UserInfoContainer,
    UserInfoContent,
    UserPhoto
} from "../../../../components/ui/Content";
import moment from "moment/moment";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {FemaleAvatar, MaleAvatar, Photo} from "../../../../icon/Icon";
import {AvatarModal, ModalsEditMenuBackground} from "../../../../components/ui/Modal";
import {EditAvatarModal} from "../Modals/EditAvatarModal";
import {cleanError, setChangeDataModal} from "../api/slice";
import {ChangePhoneModal} from "../ChangePhone/ChangePhoneModal";
import {DataForChange} from "../../../../enum/personalInfo";
import {ChangeEmailModal} from "../ChangeEmail/ChangeEmailModal";
import {cleanErrorEnter, setChangeDataForChangeNull, setChangeSuccessFalse} from "./slice";
import {GetPassword, cleanAllErrors} from "../../../Passport/Security/api/slice";
import {ChangePasswordModal} from "../ChangePassword/ChangePasswordModal";
import {getPasswordChangeIntent, setPasswordChangeIntent} from "../ChangePassword/passwordChangeIntent";

interface IDaysText {
    [key: number]: string[]
}

enum datesEnum {
    seconds,
    minutes,
    hours,
    days,
    months,
    years,
}

const datesText: IDaysText = {
    1: ["секунду", "минуту", "час", "день", "месяц", "год"],
    2: ["секунды", "минуты", "часа", "дня", "месяца", "года"],
    3: ["секунды", "минуты", "часа", "дня", "месяца", "года"],
    4: ["секунды", "минуты", "часа", "дня", "месяца", "года"],
    11: ["секунд", "минут", "часов", "дней", "месяцев", "лет"],
    12: ["секунд", "минут", "часов", "дней", "месяцев", "лет"],
    13: ["секунд", "минут", "часов", "дней", "месяцев", "лет"],
    14: ["секунд", "минут", "часов", "дней", "месяцев", "лет"],
};

interface IUserInfoProps {
    goToEditProfile: () => void
    isVerified?: boolean
    goToProfileInfo: () => void
    isIdentityCardVerified?: boolean
}

let initMenu: HTMLDivElement;

export const UserInfoCard = ({goToEditProfile, goToProfileInfo, isIdentityCardVerified}: IUserInfoProps) => {

    const {personalInfo,avatar, phone, email, changeDataModal} = useAppSelector(state => state.account)
    const {passwordDate} = useAppSelector(state => state.security)
    const [avatarMenu, setAvatarMenu] = useState<boolean>(false);
    const [showEditPassword, setShowEditPassword] = useState(false)
    const [dateFormat, setDateFormat] = useState<{ count: number, format: datesEnum }>()

    const dispatch = useAppDispatch()
    const menuRef = useRef(initMenu);

    useEffect(() => {
        moment.locale('ru');
        dispatch(GetPassword())
    }, [])

    useEffect(() => {
        if (getPasswordChangeIntent()) {
            dispatch(cleanAllErrors())
            setShowEditPassword(true)
        }
    }, [])

    const closePasswordModal = () => {
        setShowEditPassword(false)
        setPasswordChangeIntent(false)
    }

    useEffect(() => {
        if (passwordDate) {
            const utcMoment = moment.utc();
            const date = moment.duration(moment(utcMoment).diff(moment.utc(passwordDate)))
            const currDate =
                date.asYears() >= 1 && {count: Math.floor(date.asYears()), format: datesEnum.years}
                || date.asMonths() >= 1 && {count: Math.floor(date.asMonths()), format: datesEnum.months}
                || date.asDays() >= 1 && {count: Math.floor(date.asDays()), format: datesEnum.days}
                || date.asHours() >= 1 && {count: Math.floor(date.asHours()), format: datesEnum.hours}
                || date.asMinutes() >= 1 && {count: Math.floor(date.asMinutes()), format: datesEnum.minutes}
                || {count: Math.floor(date.asSeconds()), format: datesEnum.seconds}
            if (currDate) {
                setDateFormat(currDate)
            }
        }
    }, [passwordDate])

    useEffect(() => {
        const onClick = (e: MouseEvent) => {
            if (avatarMenu) {
                menuRef.current?.contains(e.target as Node) || setAvatarMenu(false);
            }
        }
        document.addEventListener('click', onClick);
        return () => document.removeEventListener('click', onClick);
    }, [avatarMenu]);

    return (<>
            <UserInfo
                className={(isIdentityCardVerified && personalInfo.sex && personalInfo.birthdate) ? 'verifiedCard' : ''}
                cursor={(isIdentityCardVerified && personalInfo.sex && personalInfo.birthdate) ? 'pointer' : 'default'}
                onClick={(e) => {
                    if (e.target === e.currentTarget && isIdentityCardVerified && personalInfo.sex && personalInfo.birthdate) {
                        goToProfileInfo()
                    }
                }}>
                <UserInfoContainer>
                    <UserPhoto>
                        {!avatarMenu && !avatar &&
                            <FormAvatar size={64} onClick={(e) => {
                                e.stopPropagation()
                                setAvatarMenu(true)
                            }}>
                                <Layer/>
                                <IconContent>
                                    <Photo/>
                                </IconContent>
                                {(!personalInfo.sex || personalInfo.sex?.name === "Мужской") && <MaleAvatar/> ||
                                    <FemaleAvatar/>}
                            </FormAvatar> ||
                            <>
                                {!avatarMenu &&
                                    <FormAvatar size={64} onClick={(e) => {
                                        e.stopPropagation()
                                        setAvatarMenu(true)
                                    }}>
                                        {avatar &&
                                            <AvatarImg src={`${process.env.REACT_APP_API}${avatar.path}`}/>}
                                        <Layer/>
                                        <IconContent>
                                            <Photo/>
                                        </IconContent>
                                    </FormAvatar>
                                    || <SelectedFormAvatar size={64} onClick={(e) => {
                                        e.stopPropagation()
                                        setAvatarMenu(false)
                                    }}>
                                        {avatar &&
                                            <AvatarImg src={`${process.env.REACT_APP_API}${avatar.path}`}/>}
                                        <Layer/>
                                        <IconContent>
                                            <Photo/>
                                        </IconContent>
                                    </SelectedFormAvatar>
                                }
                            </>}
                        {!isIdentityCardVerified && <>
                            {(personalInfo.sex || personalInfo.birthdate) &&
                                <Body1PointerLinkXs style={{marginLeft: 'auto'}} onClick={goToEditProfile}
                                                    className={'personalInfoChange'}>
                                    Изменить
                                </Body1PointerLinkXs>}
                        </>}
                    </UserPhoto>


                    <UserInfoContent onClick={() => {
                        if (isIdentityCardVerified && personalInfo.sex && personalInfo.birthdate) {
                            goToProfileInfo()
                        }
                    }}>
                        <Title> {`${personalInfo.surname} ${personalInfo.name} ${personalInfo.patronymic || ''}`}</Title>
                        <UserDataContent>
                            <PersonInfoContent>
                                {personalInfo.birthdate && <Body1>{personalInfo.birthdate?.format('LL')}</Body1> ||
                                    <Body1PointerLink onClick={goToEditProfile}>
                                        Указать дату рождения
                                    </Body1PointerLink>
                                }
                                {personalInfo.sex && <Body1>{personalInfo.sex.name}</Body1> ||
                                    <Body1PointerLink onClick={goToEditProfile}>
                                        Указать пол
                                    </Body1PointerLink>
                                }
                            </PersonInfoContent>
                            {!isIdentityCardVerified && <>
                                {(!personalInfo.sex && !personalInfo.birthdate) &&
                                    <Body1PointerLink onClick={goToEditProfile}>
                                        Указать персональную информацию
                                    </Body1PointerLink>}
                            </>}
                        </UserDataContent>
                    </UserInfoContent>
                    {!isIdentityCardVerified && <>
                        {(personalInfo.sex || personalInfo.birthdate) &&
                            <Body1PointerLinkXl style={{marginLeft: 'auto'}} onClick={goToEditProfile}
                                                className={'personalInfoChange'}>
                                Изменить
                            </Body1PointerLinkXl>}
                    </>}

                    {avatarMenu &&
                        <>
                            <ModalsEditMenuBackground/>
                            <AvatarModal ref={menuRef}>
                                <EditAvatarModal
                                    onSubmit={() => setAvatarMenu(false)}
                                    onGoBack={() => setAvatarMenu(false)}
                                />
                            </AvatarModal>
                        </>
                    }
                </UserInfoContainer>

                <Hr/>

                <UserInfoContact>
                    <TitleСontact>Контактная информация</TitleСontact>
                    <ContactPhoneEmail>
                        <ContactInfo>
                            <TitlePhoneEmail>Номер телефона</TitlePhoneEmail>
                            <DescrPhoneEmail>{phone}</DescrPhoneEmail>
                        </ContactInfo>
                        <Body1PointerLink
                            style={{marginLeft: 'auto'}}
                            onClick={() => {
                                dispatch(setChangeDataModal({
                                    dataForChange: null,
                                    type: DataForChange.phone,
                                    opened: true,
                                    success: false,
                                }))
                                dispatch(setChangeSuccessFalse())
                                dispatch(setChangeDataForChangeNull())
                                dispatch(cleanErrorEnter('phone'));
                                dispatch(cleanErrorEnter('phone_confirm'));
                                dispatch(cleanErrorEnter('data'));
                            }
                            }
                            className={'personalInfoChange'}>
                            Изменить
                        </Body1PointerLink>
                    </ContactPhoneEmail>
                    <ContactPhoneEmail>
                        <ContactInfo>
                            <TitlePhoneEmail>Электронная почта</TitlePhoneEmail>
                            <DescrPhoneEmail>{email}</DescrPhoneEmail>
                        </ContactInfo>
                        <Body1PointerLink
                            style={{marginLeft: 'auto'}}
                            onClick={() => {
                                dispatch(setChangeDataModal({
                                    dataForChange: null,
                                    type: DataForChange.email,
                                    opened: true,
                                    success: false,
                                }))
                                dispatch(setChangeSuccessFalse())
                                dispatch(setChangeDataForChangeNull())
                                dispatch(cleanError('code'));
                                dispatch(cleanError('data'));
                            }}
                            className={'personalInfoChange'}>
                            Изменить
                        </Body1PointerLink>
                    </ContactPhoneEmail>
                    <ContactPhoneEmail>
                        <ContactInfo>
                            <TitlePhoneEmail>Пароль</TitlePhoneEmail>
                            {dateFormat && (
                                (datesText[dateFormat.count % 10] && (dateFormat.count < 10 || !datesText[Number(String(dateFormat.count).slice(-2))]))
                                    ? <DescrPhoneEmail>Пароль был изменен {dateFormat.count} {datesText[dateFormat.count % 10][dateFormat.format]} назад</DescrPhoneEmail>
                                    : <DescrPhoneEmail>Пароль был изменен {dateFormat.count} {datesText[11][dateFormat.format]} назад</DescrPhoneEmail>
                            )}
                        </ContactInfo>
                        <Body1PointerLink
                            style={{marginLeft: 'auto'}}
                            onClick={() => {
                                dispatch(cleanAllErrors())
                                setShowEditPassword(true)
                            }}
                            className={'personalInfoChange'}>
                            Изменить
                        </Body1PointerLink>
                    </ContactPhoneEmail>
                </UserInfoContact>
                {showEditPassword && <ChangePasswordModal onClose={closePasswordModal}/>}
                {changeDataModal.opened && changeDataModal.type === DataForChange.phone && <ChangePhoneModal/>}
                {changeDataModal.opened && changeDataModal.type === DataForChange.email && <ChangeEmailModal/>}
            </UserInfo>
        </>
    )
}